/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyRejectRequest {
    getFixupPrototypeFunction() { return CostAnomalyRejectRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyRejectRequest>): CostAnomalyRejectRequest {
        let obj = Object.assign(new CostAnomalyRejectRequest(), model);
        CostAnomalyRejectRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyRejectRequest>): CostAnomalyRejectRequest {
        if (!model) return null;
        return CostAnomalyRejectRequest.newInstance(<CostAnomalyRejectRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyRejectRequest) {
        if (!obj) return;

        models.CostAnomalyRejectRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyRejectRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalyRejectRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.bill_date === "string") {
            this.bill_date = new Date(<string><any>this.bill_date);
        }
        if (typeof this.reject_until === "string") {
            this.reject_until = new Date(<string><any>this.reject_until);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Bill date in yyyy-mm-dd format
     */
    bill_date: Date;

    /**
     * Product Category name
     */
    product_category: string;

    /**
     * Resource Category name
     */
    resource_category: string;

    reject_until: Date;

    reject_reason: string;

}
